import { createDeviceDetector } from 'next-vue-device-detector'

export default createDeviceDetector()
